import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual } from 'lodash';
import feature from '../../utils/feature';
import { getPlatformBasedUrl } from '../../config/platformBasedUrls/url';
import { getFleetDashBoardLink, systemOldViewCheck } from '../../containers/Layouts/actions';
const CheckPageAccess = props => {
  const { pathname } = props.history.location;
  const [oldview, Setoldview] = useState(false);
  const {
    pageName,
    companyInfo,
    companyId,
    featureList,
    showPage,
    setShowHidePage,
    einOptIn,
    accountData,
    viewOnlyAccess,
    countryCode,
    forwardTo,
    systemOldView,
    getFleetDashBoardLink,
    systemOldViewCheck

  } = props;

  useEffect(
    () => {
      let redirectToDashboard = false;
      let loaded = false;

      const belongsToUs = isEqual(countryCode, 'US');
      const isUser = accountData && accountData.roles && isEqual(accountData.roles, []) === true;
      const isDemo = accountData && accountData.roles && accountData.roles.includes('demo');
      const notBelongsToUS = countryCode && countryCode !== 'US';
      if (oldview == false) {
        Setoldview(true);
      }

      if (!isEmpty(featureList) && feature.isFeatureEnabled('FLEET_DASHBOARD') && systemOldView && systemOldView.is_old_view_enabled == false) {
        getFleetDashBoardLink();

      }
      switch (pageName) {
        case 'ein-dashboard':
          const isEinOptIn = get(companyInfo, 'ein_opt_in', false) || einOptIn;
          redirectToDashboard =
            (!isEmpty(featureList) && !(isEinOptIn && feature.isFeatureEnabled('EIN_DASHBOARD'))) || isUser || isDemo;
          loaded = !isEmpty(featureList);
          break;
        case 'ein':
          const enphaseAdmin = companyId.toString() === '5';
          redirectToDashboard = !isEmpty(featureList) && !(enphaseAdmin && feature.isFeatureEnabled('EIN_ADMIN'));
          loaded = !isEmpty(featureList);
          break;
        case 'permitting-assistance':
          redirectToDashboard =
            viewOnlyAccess ||
            (!isEmpty(featureList) &&
              !isEmpty(companyInfo) &&
              !(belongsToUs && feature.isFeatureEnabled('PERMIT_ENABLED')));
          loaded = !isEmpty(featureList);
          break;
        case 'commercial':
          redirectToDashboard =
            (!isEmpty(featureList) && !feature.isFeatureEnabled('COMMERCIAL_SHORTCUT_PAGE')) || notBelongsToUS;
          loaded = !isEmpty(featureList);
          break;
        case 'sgip-incentive':
          redirectToDashboard = viewOnlyAccess;
          loaded = true;
          break;
        case 'labor-protection':
          redirectToDashboard = viewOnlyAccess || (!isEmpty(featureList) && !feature.isFeatureEnabled('LRE_ENABLED'));
          loaded = !isEmpty(featureList);
          break;
        case 'rma-dashboard':
          redirectToDashboard = !isEmpty(featureList) && !feature.isFeatureEnabled('RMA_DASHBOARD');
          loaded = !isEmpty(featureList);
          break;
        case 'generator-tokens':
          redirectToDashboard = !isEmpty(featureList) && !feature.isFeatureEnabled('GENERATOR_TOKENS');
          loaded = !isEmpty(featureList);
          break;
        case 'data-plan-extension':
          redirectToDashboard = !isEmpty(featureList) && !feature.isFeatureEnabled('CELLMODEM_DATA_PLAN_EXTENSION');
          loaded = !isEmpty(featureList);
          break;
        default:
          loaded = true;
          break;
      }
      loaded && showPage !== !redirectToDashboard && setShowHidePage(!redirectToDashboard);

      if (redirectToDashboard) {
        forwardTo(getPlatformBasedUrl('einProgram.dashboard'));
      }
    },
    [pathname, props]
  );

  return null;
};

CheckPageAccess.propTypes = {
  companyInfo: PropTypes.object,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  featureList: PropTypes.arrayOf(PropTypes.object),
  einOptIn: PropTypes.bool,
  accountData: PropTypes.object,
  viewOnlyAccess: PropTypes.bool,
  countryCode: PropTypes.string,
  forwardTo: PropTypes.func,
  showPage: PropTypes.bool,
  setShowHidePage: PropTypes.func,
  getFleetDashBoardLink: PropTypes.func,
  systemOldViewCheck: PropTypes.func
};

const mapStateToProps = state => ({
  featureList: state.defaultReducer.featureList,
  systemOldView: state.defaultReducer.systemOldView
});

const mapDispatchToProps = dispatch => ({
  getFleetDashBoardLink: () => dispatch(getFleetDashBoardLink()),
  systemOldViewCheck: () => dispatch(systemOldViewCheck()),
});
export default connect(mapStateToProps, mapDispatchToProps)(CheckPageAccess);
